export const baseEndpoint = '/v1/opportunities/$id/financial-breakdown';

export const financialBreakdownConfigs = {
	get_financial_analysis: {
		method: 'GET',
		endpoint: `${baseEndpoint}/financial-analysis`
	},
	update_financial_analysis: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/financial-analysis`
	},
	//
	get_sources_and_uses: {
		method: 'GET',
		endpoint: `${baseEndpoint}/sources-and-uses`
	},
	update_sources_and_uses: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/sources-and-uses`
	},
	// asset breakdown
	get_asset_breakdown: {
		method: 'GET',
		endpoint: `${baseEndpoint}/asset-breakdown`
	},
	update_asset_breakdown: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/asset-breakdown`
	},

	// equity breakdown
	get_equity_breakdown: {
		method: 'GET',
		endpoint: `${baseEndpoint}/equity-breakdown`
	},
	update_equity_breakdown: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/equity-breakdown`
	},

	//financial info
	get_financial_info: {
		method: 'GET',
		endpoint: `${baseEndpoint}/financial-info`
	},
	update_financial_info: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/financial-info`
	},

	//advanced financial info
	get_advanced_financial_info: {
		method: 'GET',
		endpoint: `${baseEndpoint}/advanced-financial-info`
	},
	update_advanced_financial_info: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/advanced-financial-info`
	},

	//use-of-funds
	get_use_of_funds: {
		method: 'GET',
		endpoint: `${baseEndpoint}/use-of-funds`
	},
	update_use_of_funds: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/use-of-funds`
	},
	//supporting-documents
	get_supporting_documents: {
		method: 'GET',
		endpoint: `${baseEndpoint}/supporting-documents`
	},
	update_supporting_documents: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/supporting-documents`
	},

	//scenario-analysis
	get_scenario_analysis: {
		method: 'GET',
		endpoint: `${baseEndpoint}/scenario-analysis`
	},
	update_scenario_analysis: {
		method: 'PUT',
		endpoint: `${baseEndpoint}/scenario-analysis`
	}
}
